import { render, staticRenderFns } from "./DabuenavidaCalculator.vue?vue&type=template&id=f86de8a0"
import script from "./DabuenavidaCalculator.vue?vue&type=script&lang=js"
export * from "./DabuenavidaCalculator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports